<div class="navbar">
  <div class="page-heading">
    <h1 class="page-title">{{ pageTitle }}</h1>
    <p class="page-subtitle">{{ pageSubtitle }}</p>
  </div>

  <div class="navbar-right">
    <div class="search-box" *ngIf="searchPlaceholder">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#68728F" stroke-width="2">
        <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
      </svg>
      <input type="text" [placeholder]="searchPlaceholder" [(ngModel)]="searchQuery" />
    </div>

    <div class="profile-wrapper">
      <div class="profile" (click)="toggleProfileMenu()">
        <div class="avatar">{{ userInitials }}</div>
        <span class="user-name">{{ userName }}</span>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#68728F" stroke-width="2">
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </div>

      <div class="profile-menu" *ngIf="isProfileMenuOpen">
        <button type="button" class="logout-btn" (click)="logout()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
          Logout
        </button>
      </div>
    </div>
  </div>
</div>